/**
 * AddStaffButton
 */

import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import AddUserModal from '../AddUserModal.jsx';
import schema from './form.js';
import messages from './messages.js';

function AddStaffButton() {
  const [show, setShow] = useState(false);
  const defaultValues = { groups: [] };

  return (
    <>
      <Button onClick={() => setShow(true)}><FormattedMessage {...messages.addStaff} /></Button>
      <AddUserModal
        show={show}
        title={messages.addStaff}
        type="staff"
        schema={schema}
        defaultValues={defaultValues}
        onClose={() => setShow(false)}
      />
    </>
  );
}

AddStaffButton.propTypes = {
};

export default AddStaffButton;
